import { useQuery } from "@tanstack/react-query";
import { api } from "../api.js";

/**
 * The two reads more than one screen wants, each declared once (docs/17 §performance 4).
 *
 * Same reason `useWorkspace` exists: a second observer mounting against data that is already there asks for it
 * again, because nothing without a `staleTime` is ever fresh. The shell reads the profile to decide which tab to
 * land on, and the Studio reads it to say what it does not know; Overview reads the projects for the worklist, and
 * the Studio reads them for the rail. Declared separately that is four requests for two answers, and the
 * round-trip budget goes red.
 *
 * Half a minute of staleness costs nothing here. Everything that moves either of these — an answer written, a
 * project created, a step of the pipeline — invalidates the key, and every observer refetches at once.
 */
export const useProfile = () => useQuery({ queryKey: ["profile"], queryFn: api.profile, staleTime: 30_000, refetchInterval: api.whileReading });

export const useProjects = () => useQuery({ queryKey: ["projects"], queryFn: api.projects, staleTime: 30_000 });
